import Text, { TextType } from "components/Text";
import responsiveStyling from "lib/responsive";
import { ReactElement } from "react";
import styled from "styled-components";
import CredentialView from "./CredentialView";
import { Credential } from "../types";

const ContentFlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 24px;
  padding-top: 24px;
  ${responsiveStyling({
    ">768": `
    flex-direction: column;
    `,
  })}
`;

interface Props {
  credentials: Credential[];
}

export default function CredentialsListContainer({
  credentials,
}: Props): ReactElement {
  return (
    <ContentFlexWrapper>
      {credentials &&
        credentials.map((credential) => {
          return (
            <CredentialView key={credential.refId} credential={credential} />
            // <Text>{`${credential.title}${
            //   credential.imageUrl ? "has image" : "no image"
            // }`}</Text>
          );
        })}
      {!credentials ||
        (credentials.length === 0 && (
          <Text
            type={TextType.PARAGRAPH}
            style={{ paddingBottom: "24px", paddingTop: "12px" }}
          >
            No credentials uploaded
          </Text>
        ))}
    </ContentFlexWrapper>
  );
}
